








import { Component, Vue } from 'vue-property-decorator';
import NnnHeader from '@/components/NnnHeader.vue';
import NnnFooter from '@/components/NnnFooter.vue';

@Component({
  components: {
    NnnHeader,
    NnnFooter
  },
})
export default class App extends Vue {

}
